import WebApp from '@twa-dev/sdk'

// export const getTelegramId = async (): Promise<string> => {
//     return new Promise((resolve, reject) => {
//         if (true === validateClientSide()) {
//             const telegramId = WebApp.initDataUnsafe?.user?.id;
//             // console.log('Telegram ID:', telegramId);
//             return telegramId
//         } else {
//             console.log('Failed telegram client-side validation');
//             return ''
//         }
//     });
// };
export const getTelegramId = (): string => {
    if (true === validateClientSide()) {
        const telegramId = WebApp.initDataUnsafe?.user?.id;
        
        return telegramId?.toString() || ''
    } else {
        console.log('Failed telegram client-side validation');
        if('development' === process.env.REACT_APP_NODE_ENV) {
            return 'test123456' // TEST
        } else {
            return ''
        }
    }
};

const validateClientSide = () => {
    try {
        // 1. WebApp이 제대로 초기화되었는지 확인
        if (!WebApp.ready) {
            console.log('WebApp is not ready');
            return false;
        }

        // 2. initData가 존재하는지 확인
        if (!WebApp.initData) {
            console.log('WebApp No initData available');
            return false;
        }

        // 3. 사용자 정보가 존재하는지 확인
        if (!WebApp.initDataUnsafe?.user) {
            console.log('WebApp No user data available');
            return false;
        }

        // 4. 기본적인 사용자 정보 구조 확인
        const user = WebApp.initDataUnsafe.user;
        if (!user.id || typeof user.id !== 'number') {
            console.log('WebApp Invalid user ID');
            return false;
        }

        // 5. 텔레그램 플랫폼에서 실행되는지 확인
        if (!WebApp.platform) {
            console.log('WebApp Not running on Telegram platform');
            return false;
        }

        return true;
    } catch (error) {
        console.error('Client-side validation failed:', error);
        return false;
    }
};